export const formatPartnersPricing = (partner) => {
	const annualFee = 3000 //getNested(partner, 'annualFeePerPropertyInCents')
	const discountPercent = partner?.discountPercentage

	const calcNumberOfProperties = 1
	const baseInDollars = annualFee * 0.01
	const finalTotalWithoutDiscount = baseInDollars * 1 * calcNumberOfProperties
	const finalTotalWithDiscount = discountPercent
		? finalTotalWithoutDiscount - finalTotalWithoutDiscount * (discountPercent / 100)
		: finalTotalWithoutDiscount

	return finalTotalWithDiscount
}

export const isPartnerEnterprise = (partner) => {
	return partner?.partnerCategory === 'Enterprise' ? true : false
}
